import { Link } from "react-router-dom";
import { MaskedLines, Reveal } from "@/components/Reveal";
import { IMAGES } from "@/lib/assets";
import { ArrowUpRight } from "lucide-react";

export default function Hero({ start }) {
  return (
    <section data-testid="hero" className="relative min-h-screen bg-cream overflow-hidden">
      <div className="mx-auto max-w-[1500px] px-5 md:px-10 pt-36 md:pt-44 pb-16 grid lg:grid-cols-[1.15fr_0.85fr] gap-10 items-center">
        {/* Left: kinetic type */}
        <div>
          <Reveal delay={0.25} className="flex items-center gap-3 mb-8">
            <span className="h-px w-10 bg-amber" />
            <span className="font-sans uppercase tracking-[0.35em] text-[11px] text-amber-deep">
              Modern Science, Backed by Traditional Rituals
            </span>
          </Reveal>

          <h1 className="font-serif text-[15vw] leading-[0.86] lg:text-[7.5rem] tracking-[-0.01em] text-obsidian">
            <MaskedLines
              start={start}
              lines={["Science.", "Nature.", <span key="i" className="italic text-amber-deep">Your hair.</span>]}
            />
          </h1>

          <Reveal delay={0.6} className="mt-8 max-w-md font-sans font-light text-base md:text-lg text-obsidian/70 leading-relaxed">
            A clinical-grade hair &amp; scalp house built on the marriage of proven
            actives and time-honoured herbal ritual. Consult, analyse, and treat —
            all in one place.
          </Reveal>

          <Reveal delay={0.75} className="mt-10 flex flex-wrap gap-4">
            <Link
              to="/shop"
              data-testid="hero-shop-btn"
              className="group inline-flex items-center gap-2 bg-obsidian text-cream px-8 py-4 font-sans uppercase tracking-[0.2em] text-xs hover:bg-amber-deep transition-colors"
            >
              Shop the range
              <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </Link>
            <Link
              to="/consultation"
              data-testid="hero-consult-btn"
              className="inline-flex items-center gap-2 border border-obsidian/20 px-8 py-4 font-sans uppercase tracking-[0.2em] text-xs hover:border-obsidian hover:bg-obsidian hover:text-cream transition-colors"
            >
              Book consultation
            </Link>
          </Reveal>
        </div>

        {/* Right: product trio */}
        <Reveal delay={0.4} className="relative h-[52vh] lg:h-[72vh] overflow-hidden group">
          <img
            src={IMAGES.trio}
            alt="HairPrive product trio"
            className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
          />
          <div className="absolute bottom-5 left-5 z-10 bg-cream/85 backdrop-blur-sm px-5 py-3">
            <p className="font-sans uppercase tracking-[0.2em] text-[10px] text-obsidian/60">The Trio</p>
            <p className="font-serif text-xl">Serum · Grow · Scalp</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
